import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MobileBannerPreview from '../components/bannerManagement/MobileBannerPreview';
import ForgetPassword from '../pages/authentication/ForgetPassword';
import Login from '../pages/authentication/Login'
import ResetPassword from '../pages/authentication/ResetPassword';
import UnAuthorized from '../pages/authentication/UnAuthorized';
import Layout from '../shared/Layout'

const LayoutNavigation = (props) => {

    let userRoleIds = [];
    try {
        const roleId = props.authDetails?.roleId;
        if (Array.isArray(roleId)) {
            userRoleIds = roleId.map(Number).filter(Number.isInteger);
        } else if (typeof roleId === 'number') {
            userRoleIds = [roleId];
        } else if (typeof roleId === 'string' && roleId.trim()) {
            const parsedRoleIds = roleId.trim().startsWith('[')
                ? JSON.parse(roleId)
                : roleId.split(',');
            if (Array.isArray(parsedRoleIds)) {
                userRoleIds = parsedRoleIds.map(Number).filter(Number.isInteger);
            } else {
                userRoleIds = [Number(parsedRoleIds)].filter(Number.isInteger);
            }
        }
    } catch (error) {
        console.error("Failed to parse roleId:", error);
    }

    return (
        <Router>
            <React.Suspense fallback={null}>
                <Routes>
                    <Route exact name="Login" path="/Login" element={<Login authDetails={props.authDetails} />} />
                    {
                        (window.location.pathname.toLocaleLowerCase() !== "/login" && window.location.pathname.toLocaleLowerCase() !== "/resetpassword" && window.location.pathname.toLocaleLowerCase() !== "/forgetpassword" && window.location.pathname.toLocaleLowerCase() !== "/") ?
                            <>
                                <Route name="Layout" path="/" element={window.location.href === "http://localhost:3000/BannerPreview/" ? <MobileBannerPreview key={'MobileLayout'} /> : <Layout key={'Layout'} componentRoutes={props.componentRoutes} />} >
                                    {
                                        (userRoleIds && userRoleIds.length > 0) ?
                                            <>
                                                {props.componentRoutes && props?.componentRoutes.map((route, idx) => {
                                                    const hasRoleAccess = Array.isArray(route.roles) &&
                                                        route.roles.some(roleId => userRoleIds.includes(roleId));
                                                    return (
                                                        <React.Fragment key={idx}>
                                                            {
                                                                route.component && (
                                                                    <Route
                                                                        key={route.title}
                                                                        path={route.path}
                                                                        element={hasRoleAccess
                                                                            ? <route.component authDetails={route.authDetails} route={Route} {...props} />
                                                                            : <UnAuthorized authDetails={props.authDetails} />}
                                                                    />
                                                                )
                                                            }
                                                        </React.Fragment>)
                                                    // route.component && (
                                                    //     <Route
                                                    //         key={idx}
                                                    //         path={route.path}
                                                    //         element={<route.component authDetails={route.authDetails} route={Route}  {...props} />} />
                                                    // )
                                                })}
                                            </>
                                            :
                                            <>
                                                <Route exact name="Login" path="/Login" element={<Login authDetails={props.authDetails} />} />
                                                {/* {redirectToLogin()} */}
                                            </>
                                    }
                                </Route>
                            </>
                            :
                            <>
                                <Route exact name="Login" path="/Login" element={<Login authDetails={props.authDetails} />} />
                                {/* {redirectToLogin()} */}
                            </>
                    }

                    <Route exact name="ResetPassword" path="/ResetPassword" element={<ResetPassword authDetails={props.authDetails} />} />
                    <Route exact name="ForgetPassword" path="/ForgetPassword" element={<ForgetPassword authDetails={props.authDetails} />} />
                    {(props.authDetails?.roleId && props.authDetails.roleId > 0) ?
                        <Route path='*' exact={true} element={<UnAuthorized authDetails={props.authDetails} />} />
                        : null}
                </Routes>
            </React.Suspense>
        </Router>
    )
}

export default LayoutNavigation;